import React from 'react'
import { Link } from 'react-router-dom'

import Disclaimer from './Disclaimer/Disclaimer'
import './Footer.css'

const Footer = () => (
  <footer className="py-5 Footer">
    <div className="container">
      <div className="row">
        <div className="col small text-center">
          <Disclaimer />
          <p>
            <strong>
              Need help?{' '}
              <a
                href={process.env.REACT_APP_SUPPORT_PORTAL_URL}
                rel="noopener noreferrer"
                target="_blank"
              >
                Contact us
              </a>
              .
            </strong>
          </p>
          <ul className="nav justify-content-center my-4">
            <li className="nav-item">
              <Link className="nav-link" to="/terms">
                Terms and Conditions
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/privacy">
                CivicEngine Privacy Policy
              </Link>
            </li>
          </ul>
          <p>
            Powered by{' '}
            <a
              href="https://civicengine.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              CivicEngine
            </a>
            . Copyright © {new Date().getFullYear()}{' '}
            <a
              href="https://www.civicengine.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              CivicEngine
            </a>
            . All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js